import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { initEnvironment } from './services/environment';
import './i18n';
import './index.css';

// Detect environment (LIFF vs Browser) at startup
initEnvironment();

// When a stale index.html points to a chunk that no longer exists in S3
// (e.g. immediately after a deploy + cache invalidation), the lazy import
// resolves to the SPA fallback HTML instead of JS, and the import throws.
// Recover automatically by reloading once. The flag prevents an infinite loop
// if the failure has another cause.
const RELOAD_FLAG = 'findoryhub_chunk_reload';
window.addEventListener('error', (event) => {
  const msg = event.message || '';
  const isChunkError =
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module');
  if (isChunkError && !sessionStorage.getItem(RELOAD_FLAG)) {
    sessionStorage.setItem(RELOAD_FLAG, '1');
    window.location.reload();
  }
});
window.addEventListener('load', () => {
  // Clear the flag once the page has fully loaded so future stale-chunk
  // events are handled too.
  sessionStorage.removeItem(RELOAD_FLAG);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
